import { render, staticRenderFns } from "./ReviewTable.vue?vue&type=template&id=68cd0e4c&scoped=true&"
import script from "./ReviewTable.vue?vue&type=script&lang=js&"
export * from "./ReviewTable.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTable.vue?vue&type=style&index=0&id=68cd0e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd0e4c",
  null
  
)

export default component.exports